import { createSlice } from "@reduxjs/toolkit";

const initialQuestionnaireState = {
  page: null,
  limit: null,
  totalPages: null,
  listLoading: false,
  totalResults: null,
  actionLoading: false,
  questionnaires: [],
  allQuestionnaire: null,
  selectedQuestionnaire: null,
};

export const questionnaireManagementSlice = createSlice({
  name: "questionnaireManagementSlice",
  initialState: initialQuestionnaireState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = true;
      } else {
        state.listLoading = true;
      }
    },
    stopCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = false;
      } else {
        state.listLoading = false;
      }
    },
    getQuestionnaires: (state, action) => {
      const { page, limit, results, totalPages, totalResults } = action?.payload?.questionnaire;
      state.questionnaires = results;
      state.page = page;
      state.limit = limit;
      state.totalPages = totalPages;
      state.totalResults = totalResults;
      state.listLoading = false;
    },
    setSelectedQuestionnaire: (state, action) => {
      const selectedQuestionnaire = action?.payload?.questionnaire;
      state.actionLoading = false;
      state.selectedQuestionnaire = selectedQuestionnaire;
    },
    getAllQuestionnaire: (state, action) => {
      const totalQuestionnaire = action?.payload?.questionnaire;
      state.actionLoading = false;
      state.allQuestionnaire = totalQuestionnaire;
    },
  },
});
